<template>
<div class="drawerWrap">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-width="120px">
      <el-form-item label="巡检模板" prop="templateId">
        <el-select v-model="form.templateId" placeholder="请选择巡检模板" @change="selectChange">
          <el-option v-for="item in options" :key="item.templateId" :label="item.templateName" :value="item.templateId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="巡检时间" prop="checkDate">
        <el-date-picker v-model="form.checkDate" :picker-options="pickerOptions" type="date" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="巡检人" prop="userId">
        <el-select v-model="form.userId" placeholder="请选择巡检模板" @change="selectChange" disabled>
          <el-option v-for="item in options1" :key="item.id" :label="item.nickName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    templateId: {
      type: String,
      default: ""
    },
    templateName: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的 
        }
      },
      form: {
        // userId:this.storage.getSession("userId"),
        templateId: '',
        checkDate: null,
        userId: null
      },
      formRules: {
        // templateId: [{
        //   required: true,
        //   validator: this.validateTemplateName,
        //   trigger: "blur"
        // }],
        templateId: [{
          required: true,
          message: "巡检模板不能为空",
          trigger: "change"
        }, ],
        checkDate: [{
          required: true,
          message: "巡检时间不能为空",
          trigger: "change"
        }, ],
        userId: [{
          required: true,
          message: "巡检人不能为空",
          trigger: "change"
        }, ]
      },
      flag: false,
      isHave: true,
      options: [],
      options1: [],
    };
  },
  created() {
    this.getTemplatePageList()
    this.getPollingUserList()
  },
  mounted() {
    // this.init();
  },
  methods: {
    selectChange(tempId) {
      this.request.get('/front/polling/plan/getPollingTemplateUserList', { tempId }).then(res => {
        if (res.code == 200) {
          console.log(res)
          this.form.userId = res.data.id
        } else if (res.code == 500) {
          this.form.userId = ''
          this.msg.warn(res.msg)
        }
      })
    },
    // /front/polling/template/templatePageList获取模板列表
    getTemplatePageList() {
      let params = {
        page: 1,
        pageSize: 1000,
      }
      this.request
        .get("/front/polling/template/templatePageList", params)
        .then(res => {
          console.log(res);

          if (res.code == 200) {
            this.options = res.data.pageData;
          } else {
            this.options = []
          }
        })
        .catch(error => console.log(error));
    },
    getPollingUserList() { //获取巡检人列表
      this.request
        .get("/front/polling/plan/getPollingUserList")
        .then(res => {
          console.log(res);

          if (res.code == 200) {
            this.options1 = res.data;
          } else {
            this.options1 = []
          }
        })
        .catch(error => console.log(error));
    },
    /**
     * 页面数据校验
     */
    validateTemplateName(rule, value, callback) {
      if (value === "") {
        callback(new Error("巡检计划名称不能为空"));
      } else if (value.length > 20) {
        callback(new Error("巡检计划名称长度不能超过20个字符"));
      } else {
        callback();
      }
    },
    /**
     * 页面初始化
     */
    init() {

    },

    /**
     * 取消
     */
    cancelHandle() {
      this.$emit("cancel", false);
    },
    /**
     * 确认
     */
    confirmHandle() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        this.form.checkDate = this.timeInit.getYMD(this.form.checkDate)
        this.$emit("confirm", this.form);
        this.$emit("update:loading", true);
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.drawerWrap {
  font-size: 0;
}
</style><style lang="scss">
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

  .el-select .el-input .el-select__caret {
    line-height: 50px !important;
  }
}
</style>
